import { render, staticRenderFns } from "./_base-textarea.vue?vue&type=template&id=0acdf541&scoped=true&"
import script from "./_base-textarea.vue?vue&type=script&lang=js&"
export * from "./_base-textarea.vue?vue&type=script&lang=js&"
import style0 from "./_base-textarea.vue?vue&type=style&index=0&id=0acdf541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acdf541",
  null
  
)

export default component.exports